import React from 'react';

function RegionSelectionStep({ state, setState, serviceData, setCurrentStep }) {
  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">Select Region</h2>
        <p className="text-gray-600">Choose the AWS region where your infrastructure will be hosted</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {Object.entries(serviceData.regions).map(([key, value]) => {
          const isSelected = state.region === key;
          return (
            <button
              key={key}
              onClick={() => {
                setState(prev => ({ ...prev, region: key }));
                setCurrentStep(3);
              }}
              className={`
                flex flex-col p-6 rounded-lg border transition-all duration-200 text-left
                ${isSelected
                  ? 'border-blue-500 bg-blue-50 shadow-md'
                  : 'border-gray-200 hover:border-blue-300 hover:bg-blue-50'
                }
              `}
            >
              <h3 className="text-lg font-semibold text-gray-900">{value.name}</h3>
              <p className="mt-2 text-sm text-gray-600">
                AWS Region: {value.region}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default RegionSelectionStep;